const regions = [
  "Île-de-France", "Provence-Alpes-Côte d'Azur", "Auvergne-Rhône-Alpes",
  "Nouvelle-Aquitaine", "Occitanie", "Hauts-de-France", "Grand Est",
  "Pays de la Loire", "Bretagne", "Normandie", "Bourgogne-Franche-Comté",
  "Centre-Val de Loire", "Corse"
];
const domtom = ["Guadeloupe", "Martinique", "Guyane", "La Réunion", "Mayotte"];

export default function InterventionZoneSection() {
  return (
    <section id="zone" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">

        <div className="text-center mb-14">
          <span className="inline-block bg-teal-100 text-teal-600 text-sm font-bold px-4 py-1.5 rounded-full mb-4">Zone d'intervention</span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-slate-900 mb-4">
            On intervient <span className="text-teal-500">partout en France</span>
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Équipes locales dans chaque région, intervention rapide garantie.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="bg-slate-50 rounded-3xl p-6 text-center">
              <img
                src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/c9cdb7a79150cbfe2e1124967caf3510.png"
                alt="Carte de France - Zones d'intervention AIRPURE"
                className="w-full max-h-80 object-contain mx-auto"
              />
              <div className="mt-5 flex items-center justify-center gap-2 text-teal-600 bg-teal-50 px-4 py-3 rounded-xl">
                <i className="ri-map-pin-line text-xl"></i>
                <span className="font-semibold text-sm">Équipes locales dans chaque région</span>
              </div>
            </div>
          </div>

          {/* Lists */}
          <div className="lg:col-span-3 space-y-6">
            <div className="bg-slate-50 rounded-2xl p-7">
              <h3 className="font-extrabold text-slate-800 text-lg mb-4 flex items-center gap-2">
                <i className="ri-map-2-line text-teal-500 text-xl"></i>
                France métropolitaine
              </h3>
              <div className="grid sm:grid-cols-2 gap-2">
                {regions.map((r, i) => (
                  <div key={i} className="flex items-center gap-2 text-slate-700 text-sm">
                    <div className="w-1.5 h-1.5 bg-teal-400 rounded-full flex-shrink-0"></div>
                    {r}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-slate-50 rounded-2xl p-7">
              <h3 className="font-extrabold text-slate-800 text-lg mb-4 flex items-center gap-2">
                <i className="ri-earth-line text-emerald-500 text-xl"></i>
                DOM-TOM
              </h3>
              <div className="flex flex-wrap gap-2">
                {domtom.map((d, i) => (
                  <span key={i} className="bg-emerald-100 text-emerald-700 text-sm font-medium px-3 py-1 rounded-full">{d}</span>
                ))}
              </div>
              <p className="mt-4 text-sm text-slate-500">
                <i className="ri-information-line mr-1"></i>
                Conditions spéciales DOM-TOM — nous contacter
              </p>
            </div>

            {/* Promises */}
            <div className="grid sm:grid-cols-3 gap-4">
              {[
                { icon: 'ri-time-line', label: 'Devis sous 48h', color: 'bg-orange-100 text-orange-600' },
                { icon: 'ri-truck-line', label: 'Installation sous 15j', color: 'bg-teal-100 text-teal-600' },
                { icon: 'ri-customer-service-line', label: 'Suivi dédié', color: 'bg-emerald-100 text-emerald-600' },
              ].map((p, i) => (
                <div key={i} className="bg-slate-50 rounded-2xl p-5 text-center">
                  <div className={`w-12 h-12 ${p.color} rounded-xl flex items-center justify-center mx-auto mb-3`}>
                    <i className={`${p.icon} text-xl`}></i>
                  </div>
                  <p className="font-bold text-slate-800 text-sm">{p.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
